"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const General_1 = require("../types/General");
const appStateSelectAppId_1 = __importDefault(require("./appStateSelectAppId"));
const buildCallableFirebaseAuthGetIdToken = ({ checkIfIsLoggedIn, requestToken, }) => ({ functionId, callbacks, executeProcesses, store, }) => {
    const appId = (0, appStateSelectAppId_1.default)(store.getState());
    const hasUserLoggedIn = checkIfIsLoggedIn(appId);
    const catchError = (error) => {
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.CATCH], error);
    };
    if (!hasUserLoggedIn) {
        catchError(new Error('User is not logged in'));
        return;
    }
    requestToken(appId)
        .then((token) => {
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.THEN], token);
    })
        .catch(catchError);
};
exports.default = buildCallableFirebaseAuthGetIdToken;
